/* ============================================================
   SOS SEARCH GUARD
   Saddle Online Shop / TOMAR'S

   Permanent owner for search-query protection.

   - Protects header search
   - Protects mobile drawer search
   - Protects dynamically inserted search forms
   - Rejects empty / extremely short / obvious junk queries
   - Keeps localized Shopify root path
   ============================================================ */

(function () {
  'use strict';

  var script =
    document.currentScript ||
    document.querySelector('script[data-sos-search-guard]');

  var redirectUrl =
    script && script.dataset.rootUrl
      ? script.dataset.rootUrl
      : '/';

  var BAD_QUERY =
    /(\bscript\b|\bselect\b|\bdrop\b|\bunion\b|\binsert\b|\bdelete\b|\bupdate\b|\btruncate\b|<|>|\{|\}|\(|\)|https?:|%3C|%3E)/i;


  function wireForm(form) {
    if (!form || form.dataset.sosSearchGuard === 'true') {
      return;
    }

    var input = form.querySelector('input[name="q"]');

    if (!input) {
      return;
    }


    form.addEventListener('submit', function (event) {
      var query = (input.value || '').trim();

      if (
        query.length < 2 ||
        query === '*' ||
        BAD_QUERY.test(query)
      ) {
        event.preventDefault();

        try {
          if (
            window.top &&
            window.top !== window.self
          ) {
            window.top.location.replace(redirectUrl);
          } else {
            window.location.replace(redirectUrl);
          }
        } catch (error) {
          window.location.href = redirectUrl;
        }
      }
    });


    form.dataset.sosSearchGuard = 'true';
  }


  function wireAllSearchForms() {
    var forms = document.querySelectorAll(
      'form[action*="/search"]'
    );

    forms.forEach(wireForm);
  }


  function initialize() {
    wireAllSearchForms();


    document.addEventListener(
      'shopify:section:load',
      wireAllSearchForms
    );


    document.addEventListener(
      'shopify:section:select',
      wireAllSearchForms
    );


    var observer =
      new MutationObserver(function () {
        wireAllSearchForms();
      });


    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

})();